import React from 'react';
import { isPresentInArray } from '../../../../../itrust_common/components/HelperFunctions';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let Procedure = props => {
  const { fieldsValues, selectedIds, handleIdsSelect, overviewName, previousExams, fieldKey, examId } = props;

  const renderTable = (values) => (
    <div className="col-12 pt-4">
      <div className="overview-table">
        <table className="table bg-light table-hover shadow-none border border-muted">
          <thead className="text-dark border border-muted">
            <tr className="text-center">
              <th scope="col"><DisplayField isVisible={true} label={"No."} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Procedure"} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Procedure Code"} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Impression pointer"} /></th>
              {overviewName && <th scope="col"><DisplayField isVisible={true} label={"Select"} /></th>}
            </tr>
          </thead>
          <tbody>
            {values?.map((procedure, index) =>
              <tr className="text-center" key={procedure.id || index}>
                <td><DisplayField isVisible={true} value={index + 1} /></td>
                <td><DisplayField isVisible={true} value={procedure.name} /></td>
                <td><DisplayField isVisible={true} value={procedure.exam_code} /></td>
                <td><DisplayField isVisible={true} value={procedure.pointer} /></td>
                {overviewName && <td>
                  <div className="custom-control custom-checkbox">
                    <input
                      onChange={() => handleIdsSelect(selectedIds, procedure.id)}
                      type="checkbox"
                      checked={isPresentInArray(selectedIds, procedure.id)}
                      className="custom-control-input" id={`procedure-select-${procedure.id}`} />
                    <label className="custom-control-label" htmlFor={`procedure-select-${procedure.id}`}></label>
                  </div>
                </td>}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <>
      {fieldsValues && <div className="row w-100">{renderTable(fieldsValues)}</div>}
      {previousExams?.filter(item => item.id !== examId).map(prevExam => {
        const values = prevExam?.[fieldKey];
        if (!values?.length) return null;

        return (
          <div className="col-12 border rounded mb-4 px-0" key={prevExam.id}>
            <div className="row mx-0">
              <OldValuesHeader
                prevExam={prevExam}
                overviewName={overviewName}
                examId={examId}
                importIds={values.map(item => item.id).filter(Boolean)}
              />
              {renderTable(values)}
            </div>
          </div>
        );
      })}
    </>
  )
}


export default Procedure;
